module.exports = __webpack_public_path__ + "static/media/thumbs-up-outline.580caf48.svg";